import '../styles/index.scss'
import 'js/_headers/_header'
import Common from 'js/_core/Common'

import App from 'js/app/App'
import FxRouter from 'js/app/routers/FxRouter'
import VcRouter from 'js/app/routers/VcRouter'

Common.debug = false

// Common.debug = process.env.NODE_ENV === 'development' // true or false
const useAjax = true
// APP
window.APP = new App(FxRouter, VcRouter, useAjax)
APP.init()